import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import moment from "moment";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { openCloseModalEliminarAppointment, doDeleteAppointment } from "./actions";

class ModalEliminarAppointment extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      validacion2: false,
    };
  }

  componentDidUpdate = (preProps) => {
    if (!preProps.isOpenModalEliminarAppointment && this.props.isOpenModalEliminarAppointment) {
      this.setState({ validacion2: false });
    }
  }
  handleCancel = () => {
    this.props.dispatch(openCloseModalEliminarAppointment(false, {}));
  }

  handleEliminar = () => {
    this.props.dispatch(doDeleteAppointment(this.props.appointment));
  }

  renderRepetitionDates = () => {
    if (this.props.isOpenModalEliminarAppointment) {
      moment.locale("es");
      const { appointment } = this.props;
      let repetitions = 0;
      const dates = [];
      const startDate = moment(appointment.startDate);
      let timeJump;
      let diffType;
      let repeat = Number(appointment.repeat);
      switch (repeat) {
        case 0: {
          timeJump = moment.duration(7, "days");
          diffType = "weeks";
          break;
        }
        case 1: {
          timeJump = moment.duration(1, "months");
          diffType = "months";
          break;
        }
        case 2: {
          timeJump = moment.duration(1, "years");
          diffType = "years";
          break;
        }
        default:
          break;
      }
      repetitions = moment(appointment.repeatEndDate).diff(startDate, diffType);
      while (repetitions > 0) {
        dates.push((
          <div key={`date-${repetitions}`}>
            {startDate.add(timeJump).format("DD/MM/YYYY - dddd DD [de] MMMM YYYY")}
          </div>
        ));
        repetitions -= 1;
      }
      return dates;
    }
  }

  render() {
    return (
      <Popup
        title={`Eliminar ${this.props.appointment.text}`}
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEliminarAppointment}
        width={500}
        height={this.props.appointment.repeatOnOff ? 300 : 200}
        contentComponent={() => (
          <div className="modal-delete-mantenedor">
            {this.props.isLoading && <LoadingOverlay />}
            {!this.state.validacion2 ? `¿Quieres eliminar ${this.props.appointment.text}?` : "Esta acción es irreversible."}
            <br />
            {this.props.appointment.repeatOnOff && (
              <div>
                Se eliminarán todas sus repeticiones asociadas.
                <div className="repetition-dates-warning">
                  {this.renderRepetitionDates()}
                </div>
              </div>
            )}
            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
              </div>
              <div>
                <Button text={!this.state.validacion2 ? "Eliminar" : "Sí, eliminar centro"} type="danger" onClick={this.handleEliminar} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEliminarAppointment: state.mantenedorFeriados.isOpenModalEliminarAppointment,
  appointment: state.mantenedorFeriados.appointment,
  isLoading: state.mantenedorFeriados.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEliminarAppointment);
